import{css}from'glamor';export default css({display:'block'}).toString();